import React from 'react';

const WrapperBlog = ({ children, className }) => {
    return (
        <div className={`md:pr-4 md:pl-4 max-w-screen w-full mx-auto xl:pr-24 pt-2 pb-2 xl:pl-24 ${className}`}>
            {children}
        </div>
    );
};

export default WrapperBlog;
